define('core/extensions/helpers/getPartial',[
    'handlebars',
], function (
    Handlebars
) {
    'use strict';

    // getPartial block helper
    // Invoke a partial by name with a context
    // For use in subexpressions where '>' is not a valid helper
    // If context is omitted the current context will be used instead
    // Usage: (getPartial 'partialName' context)
    return function (name, context, options) {
        if (typeof options === 'undefined') {
            options = context;
            context = this;  // eslint-disable-line consistent-this

            // Extend the context with any key=value options
            // passed in `getPartial`. This allows for partials
            // like <a href={{href}}></a> to be called like this:
            // (getPartial 'link' href='#'). Idea pulled from
            // `invokePartial` and `invokePartialWrapper` in the
            // Handlebars runtime.js.
            Handlebars.Utils.extend(context, options.hash);
        }
        return new Handlebars.SafeString(Handlebars.partials[name](context, options));
    };
});

